module.exports = __webpack_public_path__ + "img/senigor.b449573e.png";